/**
 * @file openExperience.js
 * Exports constants pertaining to open experiences.
 */

export const OPEN_EXPERIENCE_FETCH_FOR_USER = 'OPEN_EXPERIENCE_FETCH_FOR_USER';
export const OPEN_EXPERIENCE_SCENE_CREATE = 'OPEN_EXPERIENCE_SCENE_CREATE';
export const OPEN_EXPERIENCE_SCENE_EDIT = 'OPEN_EXPERIENCE_SCENE_EDIT';
export const OPEN_EXPERIENCE_SCENE_FIELD_PRESAVE =
  'OPEN_EXPERIENCE_SCENE_FIELD_PRESAVE';
export const OPEN_EXPERIENCE_COMPONENT_FIELD_PRESAVE =
  'OPEN_EXPERIENCE_COMPONENT_FIELD_PRESAVE';
export const OPEN_EXPERIENCE_COMPONENT_EDIT = 'OPEN_EXPERIENCE_COMPONENT_EDIT';
export const OPEN_EXPERIENCE_COMPONENT_CREATE =
  'OPEN_EXPERIENCE_COMPONENT_CREATE';
export const OPEN_EXPERIENCE_COMPONENT_DELETE =
  'OPEN_EXPERIENCE_COMPONENT_DELETE';



// WEBPACK FOOTER //
// ./src/constants/openExperience.js